import React from 'react'
import { useSelector } from 'react-redux'
import { DataGrid } from '@mui/x-data-grid'
import { Box, Grid, Typography } from '../../../../../components/mui/Core/index'
import SummaryTablePagination from '../../../../../components/SummaryTablePagination/summary-table-pagination'
import { getCurrencyFormattedValue } from '../../../../../utils/string-utils'
import SubHeader from '../../../../../components/SubHeader/sub-header'
import Constants from '../../../../../constants/en.json'
import { useTheme } from '../../../../../components/mui/Styles/index'

export function CreditInvoiceSummaryTable() {
  const theme = useTheme()
  const creditInvoices = useSelector((state) => state.creditInvoice.creditInvoices)
  const isFetchingCreditInvoices = useSelector(
    (state) => state.creditInvoice.isFetchingCreditInvoices,
  )

  const rows = creditInvoices.map((row) => ({
    id: row.index,
    creditInvoiceNumber: row.creditInvoiceNo,
    creditAppliedToInvoice: row.appliedToInvoice,
    creditAppliedAmount: row.creditMemoCreditApplied,
  }))

  const rowsRendered = rows.length > 5 ? rows.slice(0, 5) : rows

  const columns = [
    {
      field: 'creditInvoiceNumber',
      headerName: Constants.creditInvoice.CR_INVOICE_NUMBER,
      sortable: false,
      flex: 0.33,
      minWidth: 115,
    },
    {
      field: 'creditAppliedToInvoice',
      headerName: Constants.creditInvoice.APPLIED_TO,
      sortable: false,
      flex: 0.3,
      minWidth: 95,
    },
    {
      field: 'creditAppliedAmount',
      headerName: Constants.creditInvoice.CR_APPLIED,
      headerAlign: 'right',
      align: 'right',
      sortable: false,
      flex: 0.3,
      minWidth: 110,
      valueFormatter: (value) => {
        return getCurrencyFormattedValue(value)
      },
    },
  ]

  const noCreditInvoicesStyle = {
    textAlign: 'center',
    mt: 3,
  }

  const creditInvoiceTableStyle = {
    ...theme.dataGridMiniTable,
    minHeight: '160px',
    height: isFetchingCreditInvoices ? '400px' : 'auto',
  }

  return (
    <Box>
      <SubHeader title={Constants.creditInvoice.CREDIT_SUMMARY} />
      {!isFetchingCreditInvoices && rowsRendered.length === 0 ? (
        <Grid size={{ xs: 12 }} sx={noCreditInvoicesStyle}>
          <Typography variant='message' align='center'>
            {Constants.creditInvoice.THERE_ARE_NO_CREDIT_INVOICES}
          </Typography>
        </Grid>
      ) : (
        <DataGrid
          sx={creditInvoiceTableStyle}
          rows={rowsRendered}
          columns={columns}
          loading={isFetchingCreditInvoices}
          pageSize={5}
          rowsPerPageOptions={[10]}
          checkboxSelection={false}
          disableRowSelectionOnClick
          slots={{
            pagination: SummaryTablePagination,
          }}
          slotProps={{
            pagination: {
              totalRowsCount: rows.length,
              rowsRenderedCount: rowsRendered.length,
              route: '/creditinvoices',
            },
            loadingOverlay: {
              variant: 'skeleton',
              noRowsVariant: 'skeleton',
            },
          }}
        />
      )}
    </Box>
  )
}

export default CreditInvoiceSummaryTable
